/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PersonalInformationAliases {
  AUTOCOMPLETE_CARGO = 'autocomplete-cargo',
  AUTOCOMPLETE_FAMILY_STATUS = 'autocomplete-family-status',
  AUTOCOMPLETE_GENDER = 'autocomplete-gender',
  AUTOCOMPLETE_ISSUEING_STATE = 'autocomplete-issueing-state',
  AUTOCOMPLETE_NATIONAL = 'autocomplete-national',
  AUTOCOMPLETE_RELIGION = 'autocomplete-religion',
  CARGO_FIELD_EDIT = 'cargo-field-edit',
  CIVIL_INPUT = 'civil-input',
  CIVIL_NAME_FIELD = 'civil-name-field',
  CPF_NUMBER_FIELD = 'CPF-number-field',
  CPF_NUMBER_INPUT = 'cpf-number-input',
  CURP_FIELD = 'curp-field',
  CURP_INPUT = 'curp-input',
  DATE_FIELD_PROFILE_FORMULARY_DOB_PERSONAL_INFORMATION = 'date-field-profile-formulary-DOB-personal-information',
  DATE_FIELD_PROFILE_FORMULARY_INSURANCE_PERSONAL_INFORMATION = 'date-field-profile-formulary-insurance-personal-information',
  DOB_FIELD = 'DOB-field',
  FAMILY_STATUS_FIELD = 'family-status-field',
  FAMILY_STATUS_INPUT = 'family-status-input',
  FETCH_CARGO = 'fetch-cargo',
  FETCH_FAMILY_STATUS = 'fetch-family-status',
  FETCH_GENDER = 'fetch-gender',
  FETCH_ISSUING_STATE = 'fetch-issuing-state',
  FETCH_NATIONAL = 'fetch-national',
  FETCH_RELIGION = 'fetch-religion',
  FIELD_CELL_PHONE = 'field-cell-phone',
  FIELD_CUIL = 'field-cuil',
  FIELD_EMAIL = '  field-email',
  FIELD_FAMILY_STATUS_EDIT = 'field-family-status-edit',
  FIELD_GENDER = 'field-gender',
  FIELD_ISSUING_STATE_EDIT = 'field-issuing-state-edit',
  FIELD_MEDICARE_EDIT = 'field-medicare-edit',
  FIELD_NATIONAL = 'field-national',
  FIELD_NATIONAL_EDIT = 'field-national-edit',
  FIELD_PROFILE_FORMULARY_MAIN_COMPONENT_NAME_1_PERSONAL_INFORMATION = 'field-profile-formulary-main-component-name-1-personal-information',
  FIELD_PROFILE_FORMULARY_MAIN_COMPONENT_NAME_2_PERSONAL_INFORMATION = 'field-profile-formulary-main-component-name-2-personal-information',
  FIELD_PROFILE_FORMULARY_MAIN_COMPONENT_NAME_3_PERSONAL_INFORMATION = 'field-profile-formulary-main-component-name-3-personal-information',
  FIELD_PROFILE_FORMULARY_MAIN_FAMILY_NAME_PERSONAL_INFORMATION = 'field-profile-formulary-main-family-name-personal-information',
  FIELD_PROFILE_FORMULARY_MAIN_GIVEN_NAME_PERSONAL_INFORMATION = 'field-profile-formulary-main-given-name-personal-information',
  FIELD_PROFILE_FORMULARY_SOCIAL_COMPONENT_NAME_1_PERSONAL_INFORMATION = 'field-profile-formulary-social-component-name-1-personal-information',
  FIELD_PROFILE_FORMULARY_SOCIAL_COMPONENT_NAME_2_PERSONAL_INFORMATION = 'field-profile-formulary-social-component-name-2-personal-information',
  FIELD_PROFILE_FORMULARY_SOCIAL_COMPONENT_NAME_3_PERSONAL_INFORMATION = 'field-profile-formulary-social-component-name-3-personal-information',
  FIELD_PROFILE_FORMULARY_SOCIAL_FAMILY_NAME_PERSONAL_INFORMATION = 'field-profile-formulary-social-family-name-personal-information',
  FIELD_PROFILE_FORMULARY_SOCIAL_GIVEN_NAME_PERSONAL_INFORMATION = 'field-profile-formulary-social-given-name-personal-information',
  FIELD_RELIGION_EDIT = 'field-religion-edit',
  FORM_PANEL = 'form-panel',
  GENDER_FIELD = 'gender-field',
  GENDER_INPUT = 'gender-input',
  ID_NUMBER_FIELD = 'Id-number-field',
  ID_NUMBER_INPUT = 'Id-number-input',
  INPUT_CUIL = 'input-cuil',
  INPUT_EMAIL = 'input-email',
  INPUT_NATIONAL = 'input-national',
  INPUT_PROFILE_FORMULARY_MAIN_COMPONENT_NAME_1_PERSONAL_INFORMATION = 'input-profile-formulary-main-component-name-1-personal-information',
  INPUT_PROFILE_FORMULARY_MAIN_COMPONENT_NAME_2_PERSONAL_INFORMATION = 'input-profile-formulary-main-component-name-2-personal-information',
  INPUT_PROFILE_FORMULARY_MAIN_COMPONENT_NAME_3_PERSONAL_INFORMATION = 'input-profile-formulary-main-component-name-3-personal-information',
  INPUT_PROFILE_FORMULARY_MAIN_FAMILY_NAME_PERSONAL_INFORMATION = 'input-profile-formulary-main-family-name-personal-information',
  INPUT_PROFILE_FORMULARY_MAIN_GIVEN_NAME_PERSONAL_INFORMATION = 'input-profile-formulary-main-given-name-personal-information',
  INPUT_PROFILE_FORMULARY_SOCIAL_COMPONENT_NAME_1_PERSONAL_INFORMATION = 'input-profile-formulary-social-component-name-1-personal-information',
  INPUT_PROFILE_FORMULARY_SOCIAL_COMPONENT_NAME_2_PERSONAL_INFORMATION = 'input-profile-formulary-social-component-name-2-personal-information',
  INPUT_PROFILE_FORMULARY_SOCIAL_COMPONENT_NAME_3_PERSONAL_INFORMATION = 'input-profile-formulary-social-component-name-3-personal-information',
  INPUT_PROFILE_FORMULARY_SOCIAL_FAMILY_NAME_PERSONAL_INFORMATION = 'input-profile-formulary-social-family-name-personal-information',
  INPUT_PROFILE_FORMULARY_SOCIAL_GIVEN_NAME_PERSONAL_INFORMATION = 'input-profile-formulary-social-given-name-personal-information',
  INSUARANCE_FIELD = 'insuarance-field',
  ISSUER_FIELD = 'issuer-field',
  ISSUER_INPUT = 'issuer-input',
  ISSUING_FIELD = 'issuing-field',
  ISSUING_INPUT = 'issuing-input',
  MAPPER_CARGO = 'mapper-cargo',
  MAPPER_FAMILY_STATUS = 'mapper-family-status',
  MAPPER_GENDER = 'mapper-gender',
  MAPPER_ISSUING_STATE = 'mapper-issuing-state',
  MAPPER_NATIONAL = 'mapper-national',
  MAPPER_RELIGION = 'mapper-religion',
  MEDICARE_INPUT = 'medicare-input',
  OCCUPATION_FIELD = 'occupation-field',
  OCCUPATION_INPUT = 'occupation-input',
  PANEL_3 = 'panel-3',
  PHONE_NUMBER = 'phone-number',
  PROFILE_DATA_FETCH = 'profile-data-fetch',
  PROFILE_FORM = 'profile-form',
  PROFILE_LAYOUT = 'profile-layout',
  RELIGION_FIELD = 'religion-field',
  RELIGION_INPUT = 'religion-input',
  RFC_FIELD = 'rfc-field',
  RFC_INPUT = 'rfc-input',
  SOCIAL_INPUT = 'social-input',
  SOCIAL_NAME_FIELD = 'social-name-field',
  TEXT_CARGO = 'text-cargo',
  TEXT_FAMILY_STATUS = 'text-family-status',
  TEXT_GENDER = 'text-gender',
  TEXT_ISSUING_STATE = 'text-issuing-state',
  TEXT_NATIONAL = 'text-national',
  TEXT_RELIGION = 'text-religion',
}
export { PersonalInformationAliases };
